<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-1dc60391="" data-v-249f9abc="" class="content clearfix">
      <div data-v-1dc60391="" class="main">
        <div data-v-064cc9e2="" data-v-1dc60391="">
          <h1 data-v-064cc9e2="">
            低保优免申请
          </h1>
          <!-- <h2 style="display: flex;justify-content: space-between"><span>选择减免家庭类型</span><span style="color: #064A93">不记得编号？</span></h2>
                    <div style="padding: 15px 20px">
                        <el-radio size="medium" v-model="radio" label="1">低保家庭减免</el-radio>
                    </div>
                    <div style="padding: 15px 20px">
                        <el-radio size="medium" v-model="radio" label="2">优抚家庭减免</el-radio>
                    </div>
                    <div style="padding: 15px 20px">
                    <el-button type="primary" :disabled="isok" @click="submitForm('ruleForm')">确认并继续</el-button></div> -->

          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
            class="demo-ruleForm"
          >
            <el-form-item label="身份证正面：" prop="frontOfIDCard" class="cl_one">
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="身份证反面：" prop="backOfIDCard" class="jiakuan">
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="低保证编号：" prop="lowGuaranteeNumber" class="cl_one">
              <el-input
                v-model="ruleForm.lowGuaranteeNumber"
                class="jianwidth"
                placeholder="请输入低保证编号"
              ></el-input>
            </el-form-item>
            
            <el-form-item label="低保证件首页：" 
            prop="dibaozhengjianshouye" class="jiakuan">
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item
              label="低保证件内容页："
              prop="dibaozhengjianneirong"
              class="jiakuan"
            >
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item
              label="低保存折近期内容页："
              prop="dibaocunzhejinqineirong"
              class="jiakuan"
            >
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="联系人：" prop="contacts" class="cl_one">
              <el-input
                v-model="ruleForm.contacts"
                class="jianwidth"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="contactNumber">
              <el-input
                v-model="ruleForm.contactNumber"
                class="jianwidth"
                placeholder="请输入联系人电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="户号：" prop="accountNo">
              <el-input
                v-model="ruleForm.accountNo"
                class="jianwidth"
                placeholder="请输入户号"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址：" prop="address">
              <el-input
                v-model="ruleForm.address"
                class="jianwidth"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
              <!-- <el-button type="primary" @click="submitForm('ruleForm')"
                >提交</el-button
              > -->
            </el-form-item>
          </el-form>
          <div style="margin-bottom:40px">
            <h2 style="padding: 20px 20px 5px 20px">温馨提示:</h2>
            <h2 style="padding: 6px 20px;line-height: 145%;">
              一、明确优惠标准<br />
              根据省市有关文件精神，对低保户、分散供养特困户每月每户减免5立方米水费(月用水量不足5立方米的按实际减免)。
              <br />
              二、提供优质服务<br />
              (一)、市县民政部门将在保的低保和分散供养特困对象信息推送给城市供水企业,由供水企业通过信息比对确定减免对象。对象有增减异动的,由民政部门当月将异动情况推送给供水企业。信息不一致的,由社区（村)予以核实,确保优惠政策落实到户。<br />
              
              (二)、供水企业核定低保和分散供养特困用户用水信息后，直接按要求和标准进行减免,并通过微信、短信、便条等形式告知用户。减免对象通过总表供水的,由供水企业对总表进行统一减免，再由物业公司对照用户清单执行水费减免,并及时告知用户。
  
            </h2>
          </div>
          
        </div>
      </div>
      <businessAside />
    </div>
  </div>
</template>

<script>
import businessAside from "../../components/aside";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: "",
      textarea: "",
      value1: "",
      ruleForm: {
        frontOfIDCard:'',//身份证正面
        backOfIDCard: "",//身份证反面
        lowGuaranteeNumber:'',//低保证编号
        dibaozhengjianshouye:'',//低保证件首页
        dibaozhengjianneirong:'',//低保证件内容页
        dibaocunzhejinqineirong: "",//低保存折近期内容页
        contacts: "",//联系人
        contactNumber: "",//联系电话
        accountNo: "",//户号
        address:'',//地址
      },
      rules: {
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        contactNumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        lowGuaranteeNumber: [
          { required: true, message: "请输入低保证编号", trigger: "blur" },
        ],
        frontOfIDCard: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
        dibaozhengjianshouye: [
            { required: true, message: '请上传低保证件首页', trigger: 'change' }
        ],
        dibaozhengjianneirong: [
          { required: true, message: '请上传低保证件内容页', trigger: 'change' }
        ],
        dibaocunzhejinqineirong: [
          { required: true, message: '请上传低保存折近期内容页', trigger: 'change' }
        ],
        accountNo: [
          { required: true, message: "请输入户号", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入地址", trigger: "change" },
        ],
      },

      // isok:true,
      // radio:'',
      // ruleForm: {
      //     name: '',
      //     region: '',
      //     yanzh:''
      // },
      // rules: {
      //     name: [
      //         { required: true, message: '请输入10位客户编号', trigger: 'blur' },
      //         { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //     ],
      //     region: [
      //         { required: true, message: '请选择活动区域', trigger: 'change' }
      //     ],
      // }
    };
  },
  watch: {
    radio(val) {
      if (val != "") {
        this.isok = false;
      }
    },
    // subType(n) {
    //     if ([0, 1, 2].indexOf(n) !== -1) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
    // isOk(n) {
    //     if (n) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm() {
      this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
    },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //         if (valid) {
    //             alert('submit!');
    //         } else {
    //             console.log('error submit!!');
    //             return false;
    //         }
    //     });
    // },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // toRegret() {
    //     const BASE_PATH = window.location.href.split('#')[0]
    //     window.location.href = BASE_PATH + '#' + '/regret_pe'
    // },
  },
  components: {
    businessAside,
  },
};
</script>

<style scoped>
h2 {
  color: #8f8f8f;
  padding: 20px;
}
</style>
